// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__pTgG9","head":"Table_head__2gCtp","col":"Table_col__36CFk"};